<template>
  <nuttrema-layout-page-content class="is-login">

    <form-reset-password
       v-if="token"
       theme="global"
       class="is-no-section-border is-no-center-scroll is-center-vertical"
      :token="token"
      :AuthenticationResetPassword="AuthenticationResetPassword"
      @submit="onFormSubmit">
    </form-reset-password>

    <nuttrema-empty-result
      v-else
      icon="far fa-qrcode">
      <template slot="text">
        <h1>{{ $t('label.missing_token') }}</h1>
        <h4>{{ $t('label.missing_token_help') }}</h4>
      </template>
    </nuttrema-empty-result>

  </nuttrema-layout-page-content>
</template>

<script>
import NuttremaLayoutPageContent from 'components/ui/layout/nuttrema-layout-page-content';
import PageResetPassword from 'components/pages/shared/reset-password/page-reset-password';

export default {
  name: 'page-professional-reset-password',
  mixins: [
    PageResetPassword,
  ],
  components: {
    NuttremaLayoutPageContent,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/professional/public/reset-password/page-professional-reset-password.vue